export default __webpack_public_path__ + "static/media/crown.ed18c5c2.png";